/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Placeholder_TaskInputs */

const en_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const de_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const fr_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const es_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const it_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const nl_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const pl_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const fi_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const da_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

const sv_story_bank_placeholder_task = /** @type {(inputs: Story_Bank_Placeholder_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was your responsibility?`)
};

/**
* | output |
* | --- |
* | "What was your responsibility?" |
*
* @param {Story_Bank_Placeholder_TaskInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_placeholder_task = /** @type {((inputs?: Story_Bank_Placeholder_TaskInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Placeholder_TaskInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_placeholder_task(inputs)
	if (locale === "fr") return fr_story_bank_placeholder_task(inputs)
	if (locale === "es") return es_story_bank_placeholder_task(inputs)
	if (locale === "it") return it_story_bank_placeholder_task(inputs)
	if (locale === "nl") return nl_story_bank_placeholder_task(inputs)
	if (locale === "pl") return pl_story_bank_placeholder_task(inputs)
	if (locale === "fi") return fi_story_bank_placeholder_task(inputs)
	if (locale === "da") return da_story_bank_placeholder_task(inputs)
	if (locale === "sv") return sv_story_bank_placeholder_task(inputs)
	return en_story_bank_placeholder_task(inputs)
});